import { RumInitConfiguration } from '@datadog/browser-rum';
import { Environment } from 'environments/environment-base';
import { shouldDiscardRumEvent } from './csp-noise-filter';

/**
 * Builds the Datadog RUM init configuration for a given environment + release version.
 *
 * Pure function (no SDK calls, no side effects) so the configuration can be asserted
 * in unit tests without initialising the RUM SDK.
 */
export function buildRumConfig(environment: Environment, version: string): RumInitConfiguration {
    return {
        applicationId: environment.datadogApplicationId,
        clientToken: environment.datadogClientToken,
        service: 'broker-ui',
        env: environment.fullEnvName,
        version,
        trackUserInteractions: true,
        silentMultipleInit: true,
        allowedTracingUrls: [environment.api.baseUrl],
        trackSessionAcrossSubdomains: true,
        useSecureSessionCookie: true,
        useCrossSiteSessionCookie: true,
        storeContextsAcrossPages: true,
        // beforeSend returns false to discard an event.
        beforeSend: event => !shouldDiscardRumEvent(event)
    };
}
